export function usd(micros: number | null | undefined): string {
  if (micros === null || micros === undefined) return '—';
  const v = micros / 1_000_000;
  return v < 0.01 && v > 0 ? `$${v.toFixed(4)}` : `$${v.toFixed(2)}`;
}

export function time(iso: string): string {
  return new Date(iso).toLocaleTimeString('tr-TR', { hour: '2-digit', minute: '2-digit' });
}

export function dateTime(iso: string): string {
  return new Date(iso).toLocaleString('tr-TR', { dateStyle: 'short', timeStyle: 'short' });
}

export const PROVIDER_NAME: Record<string, string> = {
  anthropic: 'Claude',
  openai: 'Codex / OpenAI',
  gemini: 'Gemini',
  openrouter: 'AI (ücretsiz)',
  mock: 'Mock (test)',
};

export const RUN_STATE_TEXT: Record<string, string> = {
  DRAFT: 'Hazırlanıyor',
  VALIDATED: 'Doğrulandı',
  BUDGET_RESERVED: 'Bütçe ayrıldı',
  RUNNING: 'Yanıt yazıyor',
  VERIFYING: 'Doğrulanıyor',
  COMPLETED: 'Tamamlandı',
  BLOCKED: 'Başlatılmadı',
  FAILED: 'Başarısız',
  UNKNOWN_EXTERNAL_RESULT: 'Sonuç belirsiz — tekrar denenmedi',
  CANCEL_REQUESTED: 'Durduruluyor',
  CANCELLED: 'Durduruldu',
  RECONCILIATION_PENDING: 'Mutabakat bekliyor',
};

export const BLOCK_TEXT: Record<string, string> = {
  NO_CONNECTION:
    'Bu sağlayıcı için bağlantınız yok. Ayarlar → Bağlantılar bölümünden kendi anahtarınızı ekleyin.',
  CONNECTION_REVOKED: 'Bağlantınız iptal edilmiş.',
  BUDGET_NOT_CONFIGURED: 'Ücretli çağrılar için önce bir aylık üst sınır belirleyin (Ayarlar → Bütçe).',
  BUDGET_EXHAUSTED: 'Aylık üst sınırınıza ulaşıldı. Yeni ücretli çağrı başlatılmadı.',
  PRICE_UNKNOWN: 'Seçili modelin fiyatı doğrulanmamış; çağrı başlatılmadı.',
  MODEL_NOT_CONFIGURED: 'Bağlantıda model seçili değil.',
  ROOM_AI_DISABLED: 'Bu odada AI kapalı.',
  PROVIDER_DISABLED: 'Bu sağlayıcı bu kurulumda etkin değil.',
  CONCURRENCY_LIMIT: 'Aynı anda çalışan çağrı sınırınız dolu.',
  WORKFLOW_LIMIT: 'İş akışı adım sınırı aşıldı.',
};
